/* "CONTINUE SHOPPING" RETURNS WHERE THE CUSTOMER WAS
   ---------------------------------------------------------------------------
   Both Continue shopping links on the cart page are hardcoded to
   /collections/all - the empty-cart splash button and the cart footer link.
   Across a 400-product catalogue that is almost never where the customer came
   from; they were on a category or a product, and All Products drops them at
   the top of one undifferentiated list.

   NOT document.referrer: it is empty on a direct hit, on a reload, and after
   some redirects. Measured empty on the live cart page on 2026-08-11, which is
   exactly the case that matters. Instead the last shopping page is recorded in
   sessionStorage on every page view, which survives reloads and repeat visits
   to the cart within a session.

   THE QUERY STRING IS KEPT, MINUS TRACKING PARAMS. Collection filters, sort
   order and pagination all live in the query string, and returning a customer
   to page 3 of their filtered view is the entire point. But utm_*, gclid,
   fbclid and friends would otherwise ride along into an internal link, and
   Shopify's own _ab/_fd/_sc/preview_theme_id would leak a preview session into
   a normal one. Those are stripped; everything else survives.

   Cart, checkout, account and order paths are never recorded, so the link can
   never point back at the cart itself.

   The Liquid href is left intact as the fallback. With JS off, on a fresh
   session, or if the stored value fails validation, the link behaves exactly as
   the theme intended. This only ever upgrades a working link, never replaces
   one with nothing.

   The cart DRAWER's own "Continue shopping" is a <modal-close> button, not a
   link - it closes the drawer and leaves the customer in place, which is
   already correct. Deliberately untouched.

   ---------------------------------------------------------------------------
   HISTORY - three sections were removed on 2026-08-31.

   This file used to carry three more features, all of them Webyze-specific:
   the configured-item expiry notice, promoting Webyze's "Product Preview"
   property to be the line item thumbnail, and hiding empty property rows. The
   Webyze app is uninstalled and every webyze-user-product- helper is deleted
   (verified 404), so all three acted on markup that can no longer exist.

   The file keeps its name because snippets/_meta-tags.liquid references it and
   renaming would mean re-sending that snippet, which carries the Google Search
   Console verification tag.

   assets/tcc-cart-notice.css is UNCHANGED and still required: the mixed-vendor
   warning in assets/tcc-vendor-notice.js renders with .tcc-cart-notice styling,
   and the file also carries a general overflow guard that stops a long line-item
   property value pushing the quantity stepper and remove button off a 375px
   screen.

   ---------------------------------------------------------------------------
   NO INTERVAL. The removed sections needed to watch every page for cart markup,
   so this ran setInterval(tick, 900) site-wide, forever. Section 4 only ever
   acts on cart/checkout pages, so:

     - on a shopping page it records the path once and stops. No timer.
     - on a cart page it retargets the links once, then a MutationObserver
       re-applies them if the cart re-renders over AJAX. Still no timer.

   That was the last of the permanent site-wide polls that came in with Webyze. */
(function () {
  'use strict';
  if (window.__tccCartNotice) return;
  window.__tccCartNotice = true;

  /* Paths a customer would never want "continue shopping" to return them to. */
  var NOT_SHOPPING = /^\/(cart|checkout|checkouts|account|orders|apps|tools)(\/|$)/i;
  var LAST_PAGE_KEY = 'tccLastShopPage';
  /* Shopify preview/session params and the usual ad-click identifiers. */
  var STRIP_PARAM = /^(_ab|_fd|_sc|_pos|_sid|_ss|preview_theme_id|utm_[a-z_]+|gclid|dclid|fbclid|msclkid|ttclid|twclid|igshid|mc_cid|mc_eid|epik|irclickid|_kx)$/i;

  /* Current path with tracking/preview params removed but everything else -
     filters, sort_by, page - preserved. */
  function cleanPath() {
    var qs;
    try { qs = new URLSearchParams(location.search); }
    catch (e) { return location.pathname; }

    var drop = [];
    qs.forEach(function (_, key) { if (STRIP_PARAM.test(key)) drop.push(key); });
    for (var i = 0; i < drop.length; i++) qs.delete(drop[i]);

    var s = qs.toString();
    return location.pathname + (s ? '?' + s : '');
  }

  function rememberShopPage() {
    if (NOT_SHOPPING.test(location.pathname)) return;
    try { sessionStorage.setItem(LAST_PAGE_KEY, cleanPath()); } catch (e) {}
  }

  function lastShopPage() {
    var v;
    try { v = sessionStorage.getItem(LAST_PAGE_KEY); } catch (e) { return null; }
    if (!v) return null;
    /* Root-relative only. A leading "//" is protocol-relative and would send the
       customer off-site, so it is rejected along with anything not starting "/". */
    if (v.charAt(0) !== '/' || v.charAt(1) === '/') return null;
    if (NOT_SHOPPING.test(v.split('?')[0])) return null;
    if (v === cleanPath()) return null;
    return v;
  }

  function retargetContinueLinks() {
    var target = lastShopPage();
    if (!target) return;

    var links = document.querySelectorAll('[class~="#cart-footer-link"], [class~="#splash-msg"] a[class*="#button"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.getAttribute('data-tcc-continue')) continue;
      if (!/continue shopping/i.test(a.textContent)) continue;
      a.setAttribute('data-tcc-continue', '1');
      a.setAttribute('href', target);
    }
  }

  /* Cart updates re-render the footer and the empty-cart splash, which drops
     the data-tcc-continue marker along with the retargeted href. Observing is
     cheaper than polling: nothing runs on an idle page, and the retarget below
     is guarded so repeated calls cost one querySelectorAll. */
  function watchForRerenders() {
    if (typeof MutationObserver !== 'function') return;

    var queued = false;
    var run = function () { queued = false; retargetContinueLinks(); };

    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      if (typeof requestAnimationFrame === 'function') requestAnimationFrame(run);
      else setTimeout(run, 50);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    /* A shopping page only ever records where it is. */
    if (!NOT_SHOPPING.test(location.pathname)) {
      rememberShopPage();
      return;
    }
    retargetContinueLinks();
    watchForRerenders();
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
